const Index = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/dashboard/RelatorioPerformanceTempoDescarga/Index"
  );

export default [
  {
    path: "relatorio-performance-tempo-descarga",
    name: "RelatorioPerformanceTempoDescarga",
    component: Index,
    meta: {
      title: "Relatório Performance de Tempo de Descarga",
      ensureCanSeeFunctionalities: true,
      permission: {
        name: "relatorioPerformanceTempoDescarga",
        action: "read"
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/dashboard/relatorio-performance-tempo-descarga.js